module.exports = __webpack_public_path__ + "static/media/po-Reman_Major_Pump_Hyd_Piston_Xparent.42f16282.png";